import { CHART_COLORS } from '../constants';
import { formatCurrency } from '../formatters';
import { type CurrencyKey, type RoiResults } from '../types';
import HorizontalBarChart from './HorizontalBarChart';
import styles from './Report.module.scss';

interface ReportSummaryProps {
  results: RoiResults;
  currency: CurrencyKey;
  pricingPageUrl: string;
}

export default function ReportSummary({ results, currency, pricingPageUrl }: ReportSummaryProps) {
  const overallData = [
    {
      name: 'Productivity Yield',
      value: results.productivity.total.total,
      color: CHART_COLORS.plum,
    },
    {
      name: 'Onboarding Gains',
      value: results.onboarding.total.total,
      color: CHART_COLORS.orangeDark,
    },
    {
      name: 'Retention Returns',
      value: results.retention.total.total,
      color: CHART_COLORS.plumLight,
    },
  ];

  return (
    <section className={styles.section} id="report-start" aria-label="ROI Summary">
      <div className={styles.sectionInner}>
        <div className={styles.splitLayout}>
          <div>
            <span className={styles.eyebrow}>Total ROI over 3 years</span>
            <h3 className={styles.totalValue}>
              {formatCurrency(results.totalRoi.total, currency)}
            </h3>
            <p className={styles.bodyText}>
              The above figure shows the potential total savings split between Productivity Yield,
              Onboarding Savings, and Retention Returns. The breakdown of this total is displayed in
              the full report below. Compare this potential return with Interact&apos;s pricing.
            </p>
            {pricingPageUrl && (
              <a
                href={pricingPageUrl}
                className="interact-button button--primary-light button--medium"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="button__content">Get a quote now</span>
              </a>
            )}
          </div>
          <div>
            <HorizontalBarChart data={overallData} currency={currency} height={220} />
          </div>
        </div>
      </div>
    </section>
  );
}
